export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const UPDATE_DISPLAY_SEARCH_TERM = 'UPDATE_DISPLAY_SEARCH_TERM';
export const SELECT_SEARCH_RESULT = 'SELECT_SEARCH_RESULT';
export const CLEAR_SELECTED_SEARCH_RESULT = 'CLEAR_SELECTED_SEARCH_RESULT';
